<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Add From Device List</h1>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div
            class="card-header py-3"
            v-if="!_.isEmpty(list.data) && is_loading == false"
          >
            <div class="btn-toolbar pull-right">
              <el-dropdown
                split-button
                :trigger="'click'"
                @command="handleSelectedRows"
                type="primary"
                v-if="this.selected_row.length"
                class="mr-1"
              >
                {{ this.selected_row.length }}
                {{ "item" | pluralize(this.selected_row.length) }} selected
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>Save Macbind</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <button
                class="btn btn-info"
                type="button"
                @click="showFilter = !showFilter"
              >
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body pb-0" v-if="showFilter">
              <d iv v-if="organizationId != 0">
                <div class="form-row" v-if="organizationId == 1">
                  <div class="col-md-6">
                    <!-- Audra Name -->
                    <div class="form-group form-row">
                      <label class="col-md-3 col-form-label" for="audraname">Audra</label>
                      <div class="col-md-9">
                        <div class="input-group">
                          <multiselect
                            v-model="filter.accountId"
                            :options="Object.keys(pre.audraName)"
                            :custom-label="(opt) => pre.audraName[opt]"
                            placeholder="Select Audra Name"
                            :searchable="true"
                            :multiple="false"
                            id="accountId"
                            v-bind:class="{
                              'has-error': errors.has('accountId'),
                            }"
                            name="accountId"
                          >
                          </multiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group form-row">
                      <label class="col-md-3 col-form-label" for="devicename">Name</label>
                      <div class="col-md-9">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <i class="fas fa-pencil-alt"></i>
                            </span>
                          </div>
                          <input
                            autocomplete="off"
                            type="text"
                            id="devicename"
                            name="devicename"
                            v-model="filter.devicename"
                            :class="{
                              'has-error': errors.has('name'),
                            }"
                            class="form-control"
                            placeholder="Name"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group form-row">
                      <label class="col-md-3 col-form-label" for="device_mac"
                        >Device MAC</label
                      >
                      <div class="col-md-9">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <i class="fas fa-pencil-alt"></i>
                            </span>
                          </div>
                          <input
                            autocomplete="off"
                            type="text"
                            id="device_mac"
                            name="device_mac"
                            v-model="filter.device_mac"
                            :class="{
                              'has-error': errors.has('device_mac'),
                            }"
                            class="form-control"
                            placeholder="Device MAC"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="row justify-content-end">
                      <div class="col-md-9">
                        <button type="submit" class="btn mr-3">
                          <i class="icon-search"></i> Search
                        </button>
                        <button
                          type="reset"
                          class="btn btn-outline"
                          @click="resetFilter()"
                        >
                          <i class="icon-refresh"></i> Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </d>
              <div v-else class="alert alert-light mb-0" role="alert">
                Only the admin has access to filter the data.
              </div>
            </div>
          </form>

          <div class="card-body">
            <div class="table-responsive-md">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 24px">
                      <label class="checkbox">
                        <input
                          type="checkbox"
                          v-model="is_selected_all"
                          @click="selectedRowAll()" />
                        <span class="checkmark"></span
                      ></label>
                    </th>
                    <th v-if="organizationId == 1">Audra</th>
                    <th>Device MAC</th>
                    <th>IP</th>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody class="list">
                  <tr v-for="(val, index) in list.data">
                    <td>
                      <label class="checkbox">
                        <input type="checkbox" v-model="selected_row" :value="val.id" />
                        <span class="checkmark"></span
                      ></label>
                    </td>
                    <td v-if="organizationId == 1">
                      {{ val.device_name }}
                    </td>
                    <td>{{ val.Device_MAC }}</td>
                    <td>{{ val.ip_address }}</td>
                    <td>{{ val.Name }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="no-data">
                <img src="/assets/images/no-data.svg" alt="" />
                <h3>No data found!</h3>
              </div>
            </div>
          </div>

          <div :class="{ 'card-footer': list.total > list.per_page }">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import { Notification } from "element-ui";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";
const fileDownload = require("js-file-download");

export default {
  name: "AddFromDeviceList",
  metaInfo: {
    title: "Add From Device List | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    actionCreate: false,
    actionView: false,
    actionEdit: true,
    actionDelete: true,
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: {
      audraName: [],
      status: ["Enabled", "Disabled"],
    },
    is_loading: false,
    selected_row: [],
    is_selected_all: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }
    this.api_url = "/addFromDeviceList";
    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      // await CommonAPI.getCustomPermission(
      //   "/get-custom-permission-infos?path=api/macbinding"
      // ).then((response) => {
      //   if (response.status == 200) {
      //     this.custom_permission_data = response.data;
      //   }
      // });

      // if (!_.isEmpty(this.custom_permission_data)) {
      //   this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
      //     this.custom_permission_data.action_permission,
      //     this.custom_permission_data["create_id_condition"],
      //     this.user_detail,
      //     this.custom_permission_data.enableAdministratorPermissionByDefault
      //   );
      // }

      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
    async getFilterData() {
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    reload: function () {
      this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
    },
    getList: function () {
      const _this = this;
      return new Promise((resolve, reject) => {
        let params = { page: this.list.current_page };
        params = {
          ...this.filter,
          accountId: _this.filter.accountId
            ? _this.filter.accountId
            : LocalStorage.get("accountId"),
          ...this.$route.query,
          ...params,
        };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },
    checkEditPermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["edit_id_condition"],
          this.custom_permission_data["edit_refid_condition"],
          this.custom_permission_data["edit_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    checkDeletePermission: function (data) {
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["delete_id_condition"],
          this.custom_permission_data["delete_refid_condition"],
          this.custom_permission_data["delete_custom_condition"],
          data,
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      } else {
        return false;
      }
    },
    async resetFilter() {
      this.list.current_page = 1;
      this.filter = {};
      this.is_loading = true;
      await this.getList()
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          this.empty = true;

          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });
      this.is_loading = false;
    },
    selectedRowAll: function () {
      const isSelectedAll = (this.is_selected_all = !this.is_selected_all);
      if (isSelectedAll) {
        var items = [];
        this.list.data.forEach(function (item) {
          items.push(item.id);
        });
        this.selected_row = items;
      } else {
        this.selected_row = [];
      }
    },
    handleSelectedRows() {
      const notificationMessage = "Device macbinded successfully";
      const notificationTitle = "Updated Successfully";
      const _this = this;

      axios({
        method: "PUT",
        url: "/saveDeviceMacbind",
        data: { ids: this.selected_row },
        headers: { "Content-Type": "application/json" },
      })
        .then(function (response) {
          if (response.data.code == 500) {
            Notification.error({
              title: "Save Macbind Failed",
              message: response.data.message,
              type: "error",
            });
          } else {
            Notification.success({
              title: notificationTitle,
              message: response.data.message,
              type: "success",
            });
          }
        })
        .catch((errors) => {
          if (errors.response.status === 501) {
            _this.$toaster.error(errors.response.data.errors.message);
            _this.$setErrorsFromResponse(errors.response.data.errors);
          } else if (errors.response.data) {
            _this.$toaster.error(errors.response.data.message);
            _this.$setErrorsFromResponse(errors.response.data);
          }
        })
        .finally(() => {
          this.is_selected_all = false;
          this.initialize();
        });
    },
  },
};
</script>
